"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsoleLayout = ConsoleLayout;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_router_dom_1 = require("react-router-dom");
var routes_1 = require("../../constants/routes");
var client_1 = require("../../features/apis/client");
var client_2 = require("../../features/slices/client");
var use_session_activity_1 = require("../../hooks/use-session-activity");
var hooks_1 = require("../../store/hooks");
var client_storage_1 = require("../../utils/client-storage");
var roles_1 = require("../../utils/roles");
var past_due_banner_1 = require("../billing/past-due-banner");
var footer_1 = require("../footer");
var header_1 = require("../header");
var side_nav_1 = require("../side-nav");
function ConsoleLayout(props) {
    var _a;
    var children = props.children;
    var dispatch = (0, hooks_1.useAppDispatch)();
    var accessToken = (0, hooks_1.useAppSelector)(function (state) { return state.user.token; });
    var authUser = (0, hooks_1.useAppSelector)(function (state) { return state.user.user; });
    var activeClient = (0, hooks_1.useAppSelector)(function (state) { return state.client.client; });
    var isSystemAdmin = (0, roles_1.isSystemAdministratorRole)(authUser);
    var _b = (0, react_1.useState)(true), isSideNavExpanded = _b[0], setIsSideNavExpanded = _b[1];
    (0, use_session_activity_1.useSessionActivity)();
    // The stored client can be stale (e.g. suspended since the last visit), so refresh its status on entry.
    // System administrators pick other clients and are never gated, so they skip this.
    var freshClient = (0, client_1.useGetMyClientQuery)((_a = authUser === null || authUser === void 0 ? void 0 : authUser._uid) !== null && _a !== void 0 ? _a : "", {
        skip: !accessToken || !(authUser === null || authUser === void 0 ? void 0 : authUser._uid) || !activeClient || isSystemAdmin,
    }).currentData;
    (0, react_1.useEffect)(function () {
        if (!(freshClient === null || freshClient === void 0 ? void 0 : freshClient.content))
            return;
        dispatch((0, client_2.setClient)(freshClient.content));
        (0, client_storage_1.saveClientSession)(freshClient.content);
    }, [freshClient, dispatch]);
    if (!accessToken) {
        return (0, jsx_runtime_1.jsx)(react_router_dom_1.Navigate, { to: routes_1.ROUTES.LOGIN, replace: true });
    }
    // Client resolution (fetch, suspended/no-client checks, admin selection) all
    // happen on /auth/validate — this layout just enforces its outcome.
    if (!activeClient) {
        return (0, jsx_runtime_1.jsx)(react_router_dom_1.Navigate, { to: routes_1.ROUTES.VALIDATE_ACCOUNT, replace: true });
    }
    if (activeClient.status === "SUSPENDED" && !isSystemAdmin) {
        return (0, jsx_runtime_1.jsx)(react_router_dom_1.Navigate, { to: routes_1.ROUTES.ACCOUNT_SUSPENDED, replace: true });
    }
    return ((0, jsx_runtime_1.jsxs)("div", { className: "h-screen flex overflow-hidden", children: [(0, jsx_runtime_1.jsx)(side_nav_1.SideNav, { isExpanded: isSideNavExpanded }), (0, jsx_runtime_1.jsxs)("div", { className: "flex-1 flex flex-col min-w-0", children: [(0, jsx_runtime_1.jsx)(header_1.Header, { onToggleSideNav: function () { return setIsSideNavExpanded(function (prev) { return !prev; }); } }), (0, jsx_runtime_1.jsx)(past_due_banner_1.PastDueBanner, {}), (0, jsx_runtime_1.jsx)("main", { className: "flex-1 overflow-y-auto bg-light-gray p-6", children: children !== null && children !== void 0 ? children : (0, jsx_runtime_1.jsx)(react_router_dom_1.Outlet, {}) }), (0, jsx_runtime_1.jsx)(footer_1.Footer, {})] })] }));
}
